export const DColorGradientObservable = wcardinal.ui.DColorGradientObservable;